import { ApiClient } from "../api.client";
import {
  CreateAdminUserRequest,
  CreateAdminUserResponse,
  GetUserRequest,
  GetUserResponse,
  GetUsersRequest,
  GetUsersResponse,
  UpdateTrialPeriodRequest,
  UpdateTrialPeriodResponse,
  SetUserStatusRequest,
  SetUserStatusResponse,
  GetFeatureFlagByNameRequest,
  GetFeatureFlagByNameResponse,
  UpdateFeatureFlagResponse,
  UpdateFeatureFlagRequest,
  DeleteUserRequest,
  AddAffiliateRequest,
  AddAffiliateResponse,
} from "./types";

const UsersApi = {
  getUsers(params?: GetUsersRequest) {
    return ApiClient.get<GetUsersResponse>("/admin/users", { params });
  },
  getUser(params: GetUserRequest) {
    return ApiClient.get<GetUserResponse>(`/admin/users/${params.userId}`);
  },
  getFeatureFlagByName({ name }: GetFeatureFlagByNameRequest) {
    return ApiClient.get<GetFeatureFlagByNameResponse>(
      `/admin/feature-flags/${name}`
    );
  },
  updateFeatureFlag({ name, ...body }: UpdateFeatureFlagRequest) {
    return ApiClient.patch<
      Omit<UpdateFeatureFlagRequest, "name">,
      UpdateFeatureFlagResponse
    >(`/admin/feature-flags/${name}`, body);
  },
  setUserStatus(body: SetUserStatusRequest) {
    return ApiClient.post<
      Omit<SetUserStatusRequest, "userId">,
      SetUserStatusResponse
    >(`/admin/users/${body.userId}/set-status`, { status: body.status });
  },
  downloadCsv(params?: GetUsersRequest) {
    return ApiClient.get<Blob>(`/admin/users/export/csv`, {
      params,
      headers: {
        Accept: "text/csv",
      },
      responseType: "blob",
    });
  },
  createAdminUser(body: CreateAdminUserRequest) {
    return ApiClient.post<CreateAdminUserRequest, CreateAdminUserResponse>(
      `/admins/create`,
      body
    );
  },
  updateTrialPeriod({ userId, ...body }: UpdateTrialPeriodRequest) {
    return ApiClient.post<
      Omit<UpdateTrialPeriodRequest, "userId">,
      UpdateTrialPeriodResponse
    >(`/admin/users/${userId}/update-free-trial`, body);
  },
  deleteUser({ userId }: DeleteUserRequest) {
    return ApiClient.delete(`/admin/users/${userId}/delete`);
  },
  addAffiliate({ affiliateId, ...body}: AddAffiliateRequest) {
    return ApiClient.post<Omit<AddAffiliateRequest, 'affiliateId'>, AddAffiliateResponse>(
      `/admin/users/${affiliateId}/set-affiliate`, body);
  },
};

export { UsersApi };
